export enum EColors {
	RED = "red",
	VOLCANO = "volcano",
	ORANGE = "orange",
	GOLD = "gold",
	YELLOW = "yellow",
	LIME = "lime",
	GREEN = "green",
	CYAN = "cyan",
	BLUE = "blue",
	GEEKBLUE = "geekBlue",
	PURPLE = "purple",
	MAGENTA = "magenta",
	GRAY = "gray",
	TRANSPARENT = "transparent"
}
